import React, { useContext } from 'react';
import styles from './AdviseDeleteSmtp.styles.js';
import { AppContext } from 'App.context.js';

export default function AdviceDeleteSmtp({ applyToAllHotels }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  return (
    <div>
      <div style={styles.desc}>{translate('guestlink.adviceDeleteSmtpConfig')}</div>
      {applyToAllHotels ? (
        <div style={styles.desc}>
          <b>{translate('guestlink.adviceDeleteAllSmtpConfig')}</b>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
